(() => {
(function($, Drupal1, drupalSettings1) {
    var windowWidth = function() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    };
    Drupal1.behaviors.treston_base_table = {
        attach: function(context, settings) {
        // Table list functions
        }
    };
})(jQuery, Drupal, drupalSettings);

})();
//# sourceMappingURL=treston_base_table.js.map
